import React from 'react'
import { Link } from 'react-router-dom';
import { DateConvert } from "../../helper/DateConvert";
import { getMediaUrl } from '../../helper/mediaUrl';

export default function BlogRecentPost({ allData, breadcrumb }) {
  const data = allData?.[0];
  const thumbnailUrl = getMediaUrl(data?.thumbnail);
  return (
    <>
      <section className="recent-banner" style={thumbnailUrl ? { backgroundImage: `url(${thumbnailUrl})` } : undefined} >
        <div className="recent-banner-inner">
          <div className="container">
            <div className="blog-breadcumb">
              <ul>
                <li><Link to={"/"}>Home</Link></li>
                {breadcrumb?.map((item, index) => (
                  <li key={index}>{item.name}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="recent-banner-col">
            <Link to={`/blog/${data?.slug}`} className="recent-post-col">
              <div className="image-sec">
                <img src={getMediaUrl(data?.thumbnail)} className="img-responsive" alt={data?.alt_thumbnail} />
              </div>
              <div className="content-sec">
                <div className="date-wrapper">
                  <span className="date-text">{DateConvert(data?.date)}</span>
                  <span className="space">|</span>
                  <span className="min-text">by {data?.author_name} </span>
                </div>
                <h1 className="heading">{data?.title ? `${data.title.slice(0, 60)}...` : ""}</h1>
                <div className="arrow-butn" >Read More <img src="/image/right-arrow.svg" alt="arrow" /></div>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}


